import { Stack, Typography } from "@mui/material";
import CustomButton from "components/atoms/CustomButton";
import FileCard from "components/atoms/FileCard";
import FileUploadBoard from "components/atoms/FileUploadBoard";
import React, { useState } from "react";
import { useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useCustomMutation } from "store/hooks/react-query/mutate/useMutateFunc";
import { PATIENTS_EXTERNAL_MEDICAL_REDCORDS } from "utils/reactQueryKeys";

const formatData = (data) => {
  if (!data.length) return;
  const formData = new FormData();

  data?.forEach((file, i) => formData.append(`medical_records_${i + 1}`, file));

  return formData;
};

function ImportRecordModal({ toggleModal }) {
  const { id } = useParams();
  const queryClient = useQueryClient();

  const [filesToUpload, setfilesToUpload] = useState([]);
  const onAddFiles = (files) => {
    setfilesToUpload((prev) => [...prev, ...files]);
  };
  const onDeleteFile = (file) => {
    setfilesToUpload((prev) =>
      prev.filter((_file) => _file.name !== file.name)
    );
  };

  //post visit {investigations}
  const { mutateAsync, isLoading } = useCustomMutation(
    {
      url: `/visit/patients/${id}/medical-records`,
      method: "post",
      data: formatData(filesToUpload),
    },
    {
      onSuccess: (res) => {
        queryClient.invalidateQueries(PATIENTS_EXTERNAL_MEDICAL_REDCORDS);
        toggleModal();

        toast.success("Success");
      },

      onError: (error) => {
        if (Array.isArray(error.message)) {
          return error.message.map((msg) => toast.error(msg));
        }

        return toast.error(error.message);
      },
    }
  );

  return (
    <Stack spacing={4} width={"100%"}>
      <Stack direction={"row"} spacing={3} alignItems={"center"}>
        <svg
          width="40"
          height="41"
          viewBox="0 0 40 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="20"
            cy="20.6094"
            r="19"
            fill="white"
            stroke="#CBD0DC"
            strokeWidth="2"
          />
          <path
            d="M16.2982 26.5947H14.7322C12.3344 26.4235 11.2578 24.5802 11.2578 22.9408C11.2578 21.3015 12.3344 19.4501 14.6915 19.2869C15.0259 19.2543 15.3195 19.5153 15.3439 19.8579C15.3684 20.1923 15.1156 20.4859 14.7731 20.5103C13.1908 20.6245 12.4812 21.8153 12.4812 22.949C12.4812 24.0827 13.1908 25.2735 14.7731 25.3876H16.2982C16.6326 25.3876 16.9099 25.6649 16.9099 25.9993C16.9099 26.3337 16.6326 26.5947 16.2982 26.5947Z"
            fill="#292D32"
          />
          <path
            d="M23.8082 26.5954C23.7918 26.5954 23.7837 26.5954 23.7674 26.5954C23.433 26.5954 23.1231 26.3181 23.1231 25.9837C23.1231 25.633 23.3841 25.372 23.7266 25.372C24.7298 25.372 25.627 25.0213 26.3284 24.3933C27.6007 23.2841 27.6823 21.6855 27.3397 20.56C26.9972 19.4426 26.0429 18.1621 24.3791 17.9582C24.1099 17.9256 23.8979 17.7217 23.8489 17.4525C23.5227 15.4951 22.4706 14.1412 20.872 13.6518C19.2245 13.138 17.2996 13.6437 16.1007 14.8997C14.9344 16.115 14.6652 17.8196 15.3422 19.6955C15.4564 20.0135 15.2933 20.3642 14.9752 20.4784C14.6571 20.5926 14.3064 20.4295 14.1922 20.1114C13.3685 17.8114 13.7436 15.6093 15.2199 14.0596C16.7287 12.4774 19.1511 11.8493 21.2309 12.4855C23.1394 13.0728 24.4851 14.6469 24.9745 16.8327C26.6383 17.2079 27.9759 18.4721 28.506 20.2174C29.0851 22.1178 28.5631 24.0752 27.1358 25.315C26.2305 26.1306 25.0479 26.5954 23.8082 26.5954Z"
            fill="#292D32"
          />
          <path
            d="M20.0003 28.9927C18.3609 28.9927 16.8276 28.12 15.9875 26.709C15.8978 26.5704 15.8081 26.4073 15.7347 26.2278C15.4574 25.6487 15.3105 24.9881 15.3105 24.303C15.3105 21.7175 17.4148 19.6133 20.0003 19.6133C22.5857 19.6133 24.69 21.7175 24.69 24.303C24.69 24.9963 24.5432 25.6487 24.2496 26.2523C24.1843 26.4073 24.0946 26.5704 23.9967 26.7253C23.173 28.12 21.6396 28.9927 20.0003 28.9927ZM20.0003 20.8367C18.0918 20.8367 16.534 22.3945 16.534 24.303C16.534 24.8087 16.64 25.2817 16.8439 25.714C16.9091 25.8526 16.9662 25.9668 17.0315 26.0729C17.6513 27.125 18.785 27.7693 19.9921 27.7693C21.1992 27.7693 22.3329 27.125 22.9446 26.0892C23.018 25.9668 23.0833 25.8526 23.1322 25.7385C23.3524 25.2899 23.4584 24.8168 23.4584 24.3111C23.4666 22.3945 21.9088 20.8367 20.0003 20.8367Z"
            fill="#292D32"
          />
          <path
            d="M19.5343 25.7221C19.3793 25.7221 19.2244 25.665 19.1021 25.5427L18.2946 24.7353C18.0581 24.4987 18.0581 24.1072 18.2946 23.8707C18.5311 23.6342 18.9226 23.6342 19.1591 23.8707L19.5506 24.2622L20.8556 23.0551C21.1084 22.8267 21.4918 22.8431 21.7201 23.0877C21.9485 23.3324 21.9322 23.7239 21.6875 23.9523L19.9503 25.559C19.8279 25.665 19.6811 25.7221 19.5343 25.7221Z"
            fill="#292D32"
          />
        </svg>

        <hgroup>
          <Typography variant="h6" sx={{ fontWeight: "800", fontSize: "24px" }}>
            Import record
          </Typography>
          <Typography
            sx={{ fontWeight: "400", fontSize: "14px", opacity: 0.7 }}
          >
            Select and upload the patient medical records
          </Typography>
        </hgroup>
      </Stack>
      <FileUploadBoard
        onAddFiles={onAddFiles}
        acceptedFiles={["pdf", "image"]}
      />
      <Stack spacing={2}>
        {filesToUpload.map((file) => (
          <FileCard
            file={file}
            onDeleteFile={onDeleteFile}
            key={file.name + Date.now()}
          />
        ))}
      </Stack>

      <Stack spacing={2} direction={"row"}>
        <CustomButton
          text={"Import"}
          color="secondary"
          onClick={() => mutateAsync()}
          disabled={isLoading || !filesToUpload.length}
        />
        <CustomButton
          text={"Cancel"}
          variant="containedBrown"
          onClick={toggleModal}
        />
      </Stack>
    </Stack>
  );
}

export default ImportRecordModal;
